<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { mainMenu } from '../../../stores/store';
    import { app } from '../../../stores/app';
    import { customerSettings } from '../../../stores/api';
    import SettingsAdmin from '../Settings/SettingsAdmin.svelte';
    import { SettingsManager } from '../Settings/SettingsManager';
    import SettingsAccounts from '../Settings/SettingsAccounts.svelte';
    import SettingsFeatures from '../Settings/SettingsFeatures.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import Tabs from '../../shared/Tabs.svelte';
    import { SwitchBarApp } from '../../shared/SwitchBar/SwitchBarApp';
    import UsageCollector from './UsageCollector.svelte';
    import AvailableFeaturesList from '../../shared/Features/AvailableFeaturesList.svelte';

    let switchBarApp: SwitchBarApp = new SwitchBarApp();
    let selectedId: string;

    switchBarApp.setItems([
        { id: 'settings', label: 'Settings' },
        { id: 'features', label: 'Features' },
        { id: 'usage', label: 'Usage stats' },
    ]);
    switchBarApp.selectItems(['settings']);
    switchBarApp = switchBarApp;

    onMount(() => {
        $mainMenu.currentPage = 'PageAdmin';
    });

    function updateClient() {
        SettingsManager.updateClient();
    }

    function updateCustomer() {
        SettingsManager.updateCustomer();
    }

    $: selectedId = switchBarApp.getSelectedItems()[0];
</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                {$_('Administration')}
            </div>
            <div slot="main-buttons" style="display: flex; justify-items: flex-end;">
                <Tabs
                    selectedId={switchBarApp.getSelectedItems()[0]}
                    items={switchBarApp.getItems()}
                    onChange={id => {
                        switchBarApp.selectItems([id]);
                        switchBarApp = switchBarApp;
                    }}
                />
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content">
        {#if !$app.isAdmin}
            <h3>{$_('admin_permission_required')}</h3>
        {:else}
            {#if selectedId === 'settings'}
                <div style="margin-bottom: 30px;">
                    {#if $app.isAdmin}
                        <SettingsAccounts />
                    {/if}
                    {#if get(customerSettings).admin}
                        <SettingsAdmin
                            {updateClient}
                            allowToResetData={$customerSettings.admin.show_data_reset_button ||
                                true}
                        />
                    {/if}
                    <!--{#if $app.isAdmin}-->
                    <!--    <SettingsFeatures />-->
                    <!--{/if}-->
                </div>
            {/if}
            {#if selectedId === 'usage'}
                <div style="margin-bottom: 30px; margin-right: 10px; margin-top: 30px;">
                    <UsageCollector />
                </div>
            {/if}
            {#if selectedId === 'features'}
                <div style="margin-bottom: 30px; margin-right: 10px; margin-top: 30px;">
                    <AvailableFeaturesList />
                </div>
            {/if}
        {/if}
    </div>
</TemplateStandard>
